import { useCallback, useEffect, useRef, useState } from 'react';
import type { IScreensLogging } from '../../../../../api/types';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';

export const useLogDisplayCarousel = (
  logging?: IScreensLogging,
  isVisible?: boolean,
  isAwaitingDataChange?: boolean,
) => {
  const logged = useRef(false);
  // 외곽 필터로 carousel 데이터가 보존되는 경우 logging ref가 그대로 유지되어
  // [logging] effect가 안 도는 케이스를 커버. resetDisplayCarousel 호출 시
  // counter bump로 강제 재실행.
  const [resetCounter, setResetCounter] = useState(0);

  // bridge 직접 호출 대신 AnalyticsContext 자동 머지 wrapper 사용 — SCREEN 등 공용 필드 누락 방지.
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const resetDisplayCarousel = useCallback(() => {
    logged.current = false;
    setResetCounter(c => c + 1);
  }, []);

  useEffect(() => {
    logged.current = false;
  }, [logging]);

  useEffect(() => {
    if (
      logged.current ||
      !isVisible ||
      !logging?.analytics ||
      isAwaitingDataChange
    ) {
      return;
    }
    logged.current = true;

    logAnalyticsEvent({
      name: 'DISPLAY_CAROUSEL',
      analytics: logging.analytics,
      ably_only_log: logging.ably_only_log,
    });
  }, [isVisible, logging, resetCounter, isAwaitingDataChange, logAnalyticsEvent]);

  return { resetDisplayCarousel };
};
